import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.Scheduler.SchedulerDay', {
    everyDay: 'Every day',
    everyDaysOfWeek: '<b>[ N ]</b> day(s) of the <b>[ Day of week ]</b>',
    everyDaysOfMonth: '<b>[ N ]</b> day(s) of the <b>[ Day of month ]</b>',
    specificDayOfWeek: 'Specific day of the week (one or many)',
    specificDayOfMonth: 'Specific day of the month (choose one or many)',
    lastDayOfMonth: 'On the last day of the month',
    lastWeekdayOfMonth: 'On the last weekday of the month',
    lastDayOfWeekOfMonth: '<b>[ Day of week ]</b> of the month',
    lastNDaysBeforeMonthEnd: '<b>[ N ]</b> day(s) before the end of the month',
    nearestWeekdayToDay: '<b>[ N ]</b> of the month',
    dayAndWeekdayOfMonth: '<b>[ N ]</b> <b>[ Day of week ]</b> of the month',
    every: 'Every ',
    startingDays: 'day(s) starting on the',
    month: 'of the month',
    last: 'On the last ',
    beforeEnd: 'day(s) before the end of the month',
    nearestWeekday: 'Nearest weekday (Monday to Friday) to the ',
    onThe: 'On the ',
    dayScheduler: 'Day scheduler',

    // Days of the week
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
});
